<template>
  <div
      class="nsw-form-right-block"
      v-loading="Object.keys(configSettings).length === 0"
      element-loading-text="Please wait..."
  >
    <h2>{{ configSettings["donation-title"] }}</h2>
    <div class="nsw-form-box">
      <el-row class="donation-form">
        <div v-loading="isLoading" class="w-full">
          <template v-if="configSettings">
            <!-- wont show on bpay -->
            <FormHeader v-if="activeForm !== formsArray[5]"/>
            <keep-alive>
              <component :is="activeForm"/>
            </keep-alive>
            <p class="disclaimer">
              {{ configSettings["disclaimer"] }}
            </p>
          </template>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
const FormDonationAmount = () => import("../components/FormDonation.vue");
const FormDonationDonor = () =>
    import("../components/FormDonor/FormDonationDonor.vue");
const FormAddress = () => import("../components/FormAddress.vue");
const FormPayment = () => import("../components/FormPayment/_FormPayment.vue");
const FormThankYou = () => import("../components/FormThankYou.vue");
const BpayConfirmation = () =>
    import("../components/FormPayment/BPayConfirmation.vue");

import {mapState, mapActions} from "vuex";

import FormHeader from "../components/utilities/FormHeader.vue";

export default {
  components: {FormHeader},
  data() {
    return {
      formsArray: [
        FormDonationAmount,
        FormDonationDonor,
        FormAddress,
        FormPayment,
        FormThankYou,
        BpayConfirmation,
      ],
    };
  },
  computed: {
    ...mapState({
      step: (state) => state.steps,
      isLoading: (state) => state.dataLoading,
      configSettings: (state) => state.configSettings,
    }),
    ...mapState('auth', ['bearerToken']),
    activeForm() {
      return this.formsArray[this.step - 1];
      //return this.formsArray[2];
    },
  },
  methods: {
    ...mapActions(["setConfigSettings"]),
    ...mapActions('auth', ['initiateAuthAndSetEventUser']),
  },
  async created() {

    await this.initiateAuthAndSetEventUser()

    // const accessToken = this.$cookies.isKey("__3dn_acc_tok") ? this.$cookies.get("__3dn_acc_tok") : null;

    await this.setConfigSettings();
    await this.$store.dispatch("setDonorRole", {'token_cookie': this.bearerToken});
  },
};
</script>

<style lang="scss">
* {
  font-family: "Gotham Narrow Book";
}

.w-full {
  width: 100%;
}

.toggle-options {
  display: flex;
  margin-bottom: 16px;

  width: 100%;

  .el-button {
    width: 50%;
    height: 48px;

    font-size: 18px;
    font-family: "GothamNarrow Light";
    font-weight: bold;
  }
}

.el-form-item__error--inline {
  display: block !important;
}

.el-form-item__content {
  line-height: normal;
}

.el-form-item {
  margin-bottom: 0 !important;
}

.el-button {
  margin-top: 10px;
}

.el-input {
  height: 48px;

  .el-input__inner {
    height: 48px;
  }
}

.el-input--prefix .next-btn {
  position: relative;

  span {
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 400;
  }

  .el-icon-right {
    position: absolute;
    right: 20px;
  }
}

.donation-form {
  max-width: 510px;
  margin: 0 auto;

  display: flex;

  justify-content: center;
  /*align-items: center;*/
  align-items: flex-start;
  flex-direction: row;

  p {
    margin: 4px 0;
    font-size: 12px;
    line-height: normal;

    @media (min-width: 700px) {
      font-size: 15px;
    }
  }

  .el-date-editor.el-input {
    width: 100%;
  }

  footer {
    display: flex;
    margin-top: 20px;

    .el-button {
      height: 56px;
    }

    .el-button--primary {
      width: 100%;
    }

    .el-button--plain {
      span {
        font-size: 17px;
        font-weight: bold;
      }
    }
  }

  .disclaimer {
    font-size: 13px;
    color: #414042cc;
    opacity: 80%;

    margin-top: 12px;
  }
}

.form-donor {
  .el-row {
    margin-bottom: 16px;
  }
}
</style>